function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import { FormControl, FormControlLabel, FormHelperText, FormLabel, Radio, RadioGroup as MUIRadioGroup } from '@material-ui/core';
import { RadioButtonChecked, RadioButtonUnchecked } from '@material-ui/icons';
import { setValue } from '../../lib/singleSelectHelpers';
import { withStandardOptionHelpers } from '../../lib/optionHelpers';
import useFormHelpers from '../../hooks/useFormHelpers';

let RadioGroup = ({
  disabled,
  error,
  getCheckedIcon,
  getIcon,
  getOptionKey,
  getOptionLabel,
  getOptionProps,
  getOptionValue,
  helperText,
  HelperTextProps,
  label,
  onChange,
  options,
  outputOptionLabel,
  value: selectedOption = '',
  ...props
} = {}) => {
  return React.createElement(FormControl, {
    component: "fieldset",
    margin: "normal"
  }, React.createElement(FormLabel, {
    component: "legend",
    error: error
  }, label), React.createElement(MUIRadioGroup, _extends({
    value: selectedOption,
    onChange: setValue(options, getOptionValue, onChange)
  }, props), options.map(option => React.createElement(FormControlLabel, {
    key: getOptionKey(option),
    control: React.createElement(Radio, _extends({
      inputProps: {
        'aria-label': getOptionLabel(option)
      },
      icon: getIcon(option),
      checkedIcon: getCheckedIcon(option),
      disabled: disabled
    }, getOptionProps(option))),
    label: outputOptionLabel && getOptionLabel(option),
    value: getOptionValue(option)
  }))), helperText && React.createElement(FormHelperText, _extends({
    error: error
  }, HelperTextProps), helperText));
};

RadioGroup.propTypes = {
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  getCheckedIcon: PropTypes.func,
  getIcon: PropTypes.func,
  getOptionProps: PropTypes.func,
  helperText: PropTypes.string,
  HelperTextProps: PropTypes.object,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  outputOptionLabel: PropTypes.bool,
  value: PropTypes.any
};
RadioGroup.defaultProps = {
  getCheckedIcon: () => React.createElement(RadioButtonChecked, null),
  getIcon: () => React.createElement(RadioButtonUnchecked, null),
  getOptionProps: () => {},
  HelperTextProps: {},
  outputOptionLabel: true
};
RadioGroup = withStandardOptionHelpers(RadioGroup);

const LinkedRadioGroup = props => {
  const helpers = useFormHelpers(props);
  return React.createElement(RadioGroup, helpers);
};

LinkedRadioGroup.propTypes = {
  name: PropTypes.string.isRequired
};
export { RadioGroup, LinkedRadioGroup };